/* * 本页面为角色新增和角色修改界面 * 通过pageType字段来区分：1新增，2修改 * * *
@Last Modified by: mikey.zhaopeng * @Last Modified time: 2021-04-29 10:23:18
<template>
  <div class="page-view container-view pd-lr-20">
    <!-- title -->
    <section class="title-section">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 新增内容 -->
    <section class="content-section">
      <div class="content-section__left">
        <div class="content-wrapper">
          <div class="form-wrapper">
            <e6-form-extend
              ref="formExtend"
              :formExtend="formExtend"
              :inline="false"
              label-width="90px"
            >
              <template slot-scope="slotForms">
                <el-form-item
                  prop="forms.roleName"
                  label="角色名"
                  :rules="[
                    {
                      required: true,
                      message: '请输入角色名',
                      trigger: 'blur',
                    },
                    { validator: checkRoleName, trigger: 'blur' },
                  ]"
                >
                  <el-input
                    v-model="slotForms.forms.roleName"
                    placeholder="角色名"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item class="textarea" label="备注">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="slotForms.forms.remark"
                    placeholder="备注"
                    clearable
                  ></el-input>
                </el-form-item>
              </template>
            </e6-form-extend>
          </div>
        </div>
      </div>
      <div class="content-section__middle">
        <div class="content-wrapper">
          <div class="content-header">
            <el-input clearable placeholder v-model="filterResource">
              <el-button
                @click="handleFilterResource"
                slot="append"
                icon="e6-icon-search_line"
              ></el-button>
            </el-input>
          </div>
          <div class="content-body">
            <el-tree
              class="filter-tree"
              ref="resource"
              show-checkbox
              default-expand-all
              :data="resourceList"
              :highlight-current="true"
              :expand-on-click-node="false"
              node-key="id"
              @node-click="handleNodeClick"
              @check="handleCheckChange"
              :filter-node-method="filterNode"
            ></el-tree>
          </div>
        </div>
      </div>
      <!-- **删除右边的树** -->
      <!-- <div class="content-section__right">
              <div class="content-wrapper">
                <div class="content-header">权限信息</div>
                <div class="content-body">
                  <ul class="auth-setting">
                    <li class="auth-item">
                      <div class="auth-title">权限名称</div>
                      <div class="auth-content">{{ authName }}</div>
                    </li>
                    <li class="auth-item">
                      <div class="auth-title">动作列表</div>
                      <div class="auth-content">
                        <el-checkbox
                          v-for="(authOperate, index) in authOperates"
                          :key="index"
                          :checked="authOperate.checked"
                          :disabled="authOperate.showInMenu"
                          v-model="authOperate.checked"
                          >{{ authOperate.privilegeName }}</el-checkbox
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
    </section>
    <!-- 新增内容 end -->
    <section class="btns-section">
      <div class="operate-btn">
        <el-button
          type="primary"
          @click="handleSubmitForm"
          :loading="loadingState"
          >提交
        </el-button>
        <el-button @click="handleResetForm">返回</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  FetchFindAllMenuTree,
  FetchfindExistRoleName,
  FetchFindRoleDetailByRoleId,
  FetchGetExtColumn,
  FetchSaveRole,
} from "_private/api/systemSetting/roleManage";
import { mergeFormExtend } from "_private/utils/merge";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页",
          },
        },
        {
          path: "/systemSettingRoleManageList",
          isRedirect: true,
          meta: {
            title: "角色管理",
          },
        },
      ],
      formExtend: {
        forms: {
          roleName: "",
          remark: "",
        },
        extends: [],
      },
      filterResource: "",
      resourceList: [],
      checkedAuthOperates: [],
      authOperates: [],
      authName: "",
      editCheckId: "",
      loadingState: false,
    };
  },
  computed: {
    ...mapGetters(["moduleId"]),
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle = this.pageType === "1" ? "角色新增" : "角色修改";
      this.breadcrumbs.push({
        path: "/systemSettingRoleManageEdit",
        isRedirect: false,
        meta: {
          title: pageTitle,
        },
      });
      return pageTitle;
    },
    roleId() {
      return this.$route.query.roleId;
    },
  },
  watch: {
    filterResource(val) {
      if (val === "") {
        this.$refs.resource.filter(val);
      }
    },
  },
  created() {
    let FetchGetExtColumnData = {};
    let FetchFindAllMenuTree = {};
    FetchGetExtColumnData.edit = true;
    FetchGetExtColumnData.moduleId = this.moduleId;
    if (this.pageType == 2) {
      FetchGetExtColumnData.primaryKeyId = this.roleId;
      FetchFindAllMenuTree = { roleId: this.roleId };
    } else {
      FetchGetExtColumnData.primaryKeyId = 1;
      //roleId: 1
      FetchFindAllMenuTree = {};
    }
    this.FetchGetExtColumn(FetchGetExtColumnData);
    this.FetchFindAllMenuTree(FetchFindAllMenuTree);
  },
  methods: {
    // 获取角色扩展字段
    FetchGetExtColumn(data) {
      FetchGetExtColumn(data)
        .then((response) => {
          if (response.result && Array.isArray(response.result)) {
            this.formExtend.extends.push(...response.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取角色信息
    FetchFindAllMenuTree(data) {
      FetchFindAllMenuTree(data)
        .then((response) => {
          if (response.result && Array.isArray(response.result)) {
            this.defaultCheckedNode = []; //**增加**
            this.formatAllMenuTreeData(response.result); //**增加**
            this.resourceList.push(...response.result);
            this.$nextTick(() => {
              this.$refs.resource.setCheckedKeys(this.defaultCheckedNode);
            }); //**增加**
          }
          if (this.pageType === "2") {
            this.FetchFindRoleDetailByRoleId({ roleId: this.roleId });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // **新增方法** 格式化树
    formatAllMenuTreeData(menuList) {
      menuList.forEach((item) => {
        const { children, privilegeList } = item;

        // 存在子节点
        if (Array.isArray(children)) {
          this.formatAllMenuTreeData(children);
        } else if (Array.isArray(privilegeList)) {
          item.children = privilegeList.map((v) => {
            const id = Math.random() + v.privilegeId;
            let label = v.privilegeName;
            if (v.checked) {
              this.defaultCheckedNode.push(id);
            }

            return {
              id,
              label,
              privilegeId: v.privilegeId,
              checked: v.checked,
              isLeaf: true,
            };
          });
        }
      });
    },

    // 新增、修改角色
    FetchSaveRole(data) {
      FetchSaveRole(data)
        .then((response) => {
          this.submitCallback(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 修改角色时，首先获取角色信息
    FetchFindRoleDetailByRoleId(data) {
      FetchFindRoleDetailByRoleId(data)
        .then((response) => {
          if (response.result) {
            this.formExtend.forms.remark = response.result.remark;
            this.formExtend.forms.roleName = response.result.roleName;
            let menuIds = [];
            if (
              response.result.menuIds &&
              Array.isArray(response.result.menuIds) &&
              response.result.menuIds.length > 0
            ) {
              menuIds = response.result.menuIds;
            }

            // this.setCheckedKeys(menuIds);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 过滤菜单
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 修改角色时，获取选中的菜单节点
    setCheckedKeys(data) {
      this.$refs.resource.setCheckedKeys(data);
    },
    // 修改菜单节点的checked属性
    changeNodeChecked(data, type) {
      if (data == undefined) {
        return;
      } //**新增**
      data.forEach((item) => {
        if (
          item.privilegeList &&
          Array.isArray(item.privilegeList) &&
          item.privilegeList.length > 0
        ) {
          item.privilegeList.forEach((subItem) => {
            subItem.checked = type;
          });
        }
        if (item.children) {
          this.changeNodeChecked(item.children, type);
        }
      });
    },
    // 根据勾选的菜单节点id查找对应的节点
    searchNode(data, type, id) {
      data.forEach((item) => {
        if (item.id === id) {
          if (
            item.moduleId &&
            item.privilegeList &&
            item.privilegeList.length > 0
          ) {
            item.privilegeList.forEach((subItem) => {
              subItem.checked = type;
            });
          } else {
            this.changeNodeChecked(item.children, type);
          }
        }
        if (item.children) {
          this.searchNode(item.children, type, id);
        }
      });
    },

    // 获取勾选的菜单节点
    getCheckedNodes() {
      let privilegeIds = this.$refs.resource
        .getCheckedNodes(true)
        .map((v) => v.privilegeId); //**修改**
      return privilegeIds.length < 1 ? "" : privilegeIds.join(",");
    },
    // 新增、修改用户完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$store.dispatch("getSpecialDropdownList", {
              type: "roleList",
            });
            this.$router.push("/systemSettingRoleManageList");
          }
          this.loadingState = false;
        },
      });
    },
    // 筛选菜单树
    handleFilterResource() {
      this.$refs.resource.filter(this.filterResource);
    },
    // 点击菜单树的节点
    handleNodeClick(data) {
      if (
        data.moduleId &&
        data.privilegeList &&
        Array.isArray(data.privilegeList)
      ) {
        this.authName = data.label;
        this.authOperates = data.privilegeList;
      }
    },
    //勾选菜单树
    handleCheckChange(node) {},

    // 提交
    handleSubmitForm() {
      if (!this.getCheckedNodes()) {
        this.$message({
          showClose: true,
          message: "角色的权限不能为空",
          type: "error",
          duration: 1500,
        });
      } else {
        this.$refs.formExtend.submitForm().then((val) => {
          if (val) {
            let data = {};
            if (this.pageType === "1") {
              data = Object.assign(mergeFormExtend(this.formExtend), {
                privilegeIds: this.getCheckedNodes(),
              });
            } else {
              data = Object.assign(
                mergeFormExtend(this.formExtend),
                {
                  privilegeIds: this.getCheckedNodes(),
                },
                {
                  roleId: this.roleId,
                }
              );
            }
            this.loadingState = true;
            this.FetchSaveRole(data);
          }
        });
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/systemSettingRoleManageList");
    },
    // 校验角色名称
    checkRoleName(rule, value, callback) {
      let data = { roleName: value };
      if (this.pageType === "2") {
        data.roleId = this.roleId;
      }
      FetchfindExistRoleName(data)
        .then((response) => {
          response ? callback(new Error("角色名称重复，请检查")) : callback();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.content-section {
  height: calc(100% - 53px - 58px);
  background-color: #fff;
  & > div {
    display: inline-block;
    height: 100%;
    width: 33.33%;
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .content-section__middle,
  .content-section__right {
    .content-header {
      position: absolute;
      left: 0;
      right: 0;
      height: 30px;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
      line-height: 1;
    }
    .content-body {
      position: absolute;
      top: 56px;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
    }
  }
  .content-section__left {
    padding-left: 30px;
    padding-right: 15px;
    .form-wrapper {
      padding: 20px 0;
    }
  }
  .content-section__middle {
    padding-left: 15px;
    padding-right: 15px;
    .content-header {
      font-size: 0;
    }
    .el-input {
      width: 200px;
      margin-left: 15px;
    }
  }
  .content-section__right {
    padding-left: 15px;
    padding-right: 30px;
    .content-header {
      line-height: 30px;
      text-indent: 1em;
    }
    .auth-setting {
      margin-top: 5px;
      .auth-item {
        display: flex;
        line-height: 30px;
      }
      .auth-title {
        width: 100px;
        text-align: center;
      }
      .auth-content {
        width: calc(100% - 100px);
        .el-checkbox {
          display: block;
          margin-left: 0;
        }
      }
    }
  }
  .content-wrapper {
    position: relative;
    height: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    overflow: auto;
  }
  /deep/ .el-form-item {
    margin-right: 20px;
  }
}

.btns-section {
  padding: 15px 0;
  text-align: center;
}
</style>
